import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeEuropeeItalia extends Component {
  render() {
    return (
    <div className="App">
        <EWH id="ewh-fascione-italia" repo='/elezioni/withub/electionday-2024/europee/fascione-italia.html?cid=ewh-fascione-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
        <EWH id="ewh-dettaglio-italia" repo='/elezioni/withub/electionday-2024/europee/dettaglio-italia.html?cid=ewh-dettaglio-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
    </div>
    )
  }
}

export default HomeEuropeeItalia
